import React from "react";

export default function HeaderText(prpos) {
    const { text } = prpos;
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 p-0 pt-4">
      <div class="regular-heading" style={{margin:"0 0 25px 0",height:"25px"}}>
          <div class="wptb-item--inner">
              <h6 class="subtitle" style={{fontSize:"20px",fontWeight:"600",textTransform:"none",textAlign:"center"}}>
                  <span>|| </span> 
                  {text}
                  <span> ||</span>
              </h6>
          </div>
      </div>
    </div>
  );
}
